import { useState } from 'react';
import { Card } from '../../shared/ui/components';
import { BibleTabs } from './Atlas';
import { withRefLinks } from './Dictionary';
import { BOOK_GROUPS, MANUSCRIPTS, ORIGIN, PEOPLE, TIMELINE } from './historyContent';
import { useTabParam } from '../../shared/ui/useTabParam';

type Section = 'origen' | 'libros' | 'manuscritos' | 'linea' | 'personas';
const SECTIONS: [Section, string][] = [
  ['origen', 'De dónde viene'],
  ['libros', 'Quién escribió cada libro'],
  ['manuscritos', 'Manuscritos'],
  ['linea', 'Cómo llegó hasta hoy'],
  ['personas', 'Escritores, copistas y traductores'],
];

/** Historia de la Biblia: origen, autores, manuscritos, línea del tiempo hasta la Reina-Valera y personas. */
export function BibleHistoryPage() {
  const [section, setSection] = useTabParam<Section>(SECTIONS.map(([k]) => k));
  return (
    <div className="page bible-wide">
      <BibleTabs active="historia" />
      <header className="page__header">
        <h1>Historia de la Biblia</h1>
        <p className="muted">Cómo llegó hasta nosotros la Palabra de Dios: de los autores originales a la Reina-Valera.</p>
      </header>
      <div className="tabs tabs--scroll" role="tablist" aria-label="Historia de la Biblia">
        {SECTIONS.map(([key, label]) => (
          <button key={key} type="button" role="tab" aria-selected={section === key} className={`tabs__tab${section === key ? ' tabs__tab--active' : ''}`} onClick={() => setSection(key)}>
            {label}
          </button>
        ))}
      </div>

      {section === 'origen'
        ? ORIGIN.map((s) => (
            <Card key={s.title} title={s.title}>
              {s.body.map((p, i) => (
                <p key={i}>{withRefLinks(p)}</p>
              ))}
            </Card>
          ))
        : null}

      {section === 'libros' ? (
        <>
          <p className="small muted">Autor y fecha según la tradición y los datos del propio libro; las fechas antiguas son aproximadas. Donde hay debate entre estudiosos se indica.</p>
          {BOOK_GROUPS.map((g) => (
            <Card key={g.group} title={g.group}>
              <dl className="history-books">
                {g.books.map((b) => (
                  <div key={b.book} className="history-books__item">
                    <dt>{b.book}</dt>
                    <dd>
                      <span>{withRefLinks(b.author)}</span>
                      <span className="small muted"> · {b.date}</span>
                      {b.note ? <span className="small history-books__note">{withRefLinks(b.note)}</span> : null}
                    </dd>
                  </div>
                ))}
              </dl>
            </Card>
          ))}
        </>
      ) : null}

      {section === 'manuscritos'
        ? MANUSCRIPTS.map((g) => (
            <Card key={g.group} title={g.group}>
              <ul className="history-list">
                {g.items.map((m) => (
                  <li key={m.name}>
                    <strong>{m.name}</strong> <span className="small muted">· {m.date} · {m.where}</span>
                    <p>{withRefLinks(m.text)}</p>
                  </li>
                ))}
              </ul>
            </Card>
          ))
        : null}

      {section === 'linea' ? (
        <ol className="history-timeline">
          {TIMELINE.map((e) => (
            <li key={e.year + e.title} className="history-timeline__item">
              <span className="history-timeline__year">{e.year}</span>
              <strong>{e.title}</strong>
              <p>{withRefLinks(e.text)}</p>
            </li>
          ))}
        </ol>
      ) : null}

      {section === 'personas' ? (
        <ul className="history-list">
          {PEOPLE.map((p) => (
            <li key={p.name} className="card">
              <strong>{p.name}</strong> <span className="small muted">· {p.dates} · {p.role}</span>
              <p>{withRefLinks(p.text)}</p>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
